{
  "slug": "what-is-considered-a-high-iq",
  "title": "IQ को उच्च माना जाता है।",
  "description": "यह जानना कि कौन से आईक्यू स्कोर आमतौर पर उच्च के रूप में वर्णित हैं, वे प्रतिशतों से कैसे संबंधित हैं, और विश्वसनीय अंतराल और परीक्षण संदर्भ क्यों महत्वपूर्ण हैं।",
  "summary": "एक सामान्य mean-100, मानक विचलन-15 स्केल, स्कोर के आसपास 120 औसत से ऊपर और आसपास स्कोर हैं 130 ऊपरी दो प्रतिशत के पास हैं. लेबल उपकरण के अनुसार भिन्न होते हैं तथा पूर्ण व्याख्या को बदलने के लिए नहीं हैं.",
  "category": "आईक्यू स्कोर व्याख्या",
  "sections": [
    {
      "heading": "सामान्य स्कोर तथा प्रतिशत संदर्भ बिन्दु",
      "paragraphs": [
        "आधुनिक आईक्यू स्कोर एक उम्र आधारित मानक समूह के सापेक्ष प्रदर्शन का वर्णन करते हैं। 100 के पास है 50th percentile, 115 के पास 84थ 120 के पास 91st, और 130 के पास 98यह एक सामान्य मॉडल से लगभग मान हैं, न कि सार्वभौमिक कटऑफ से.",
        "प्रकाशन और संगठन अलग-अलग वर्णन का उपयोग करते हैं. औसत से ऊपर, बेहतर, बहुत उच्च, या प्रतिभाशाली जैसे शब्दों की अलग-अलग सीमाएं हो सकती हैं, इसलिए रिपोर्ट और इसकी तकनीकी मैनुअल प्राथमिकता लेती है।"
      ],
      "bullets": [
        "110–119: जनसंख्या औसत से ऊपर",
        "120–129: कई मापों पर औसत से काफी ऊपर",
        "130 और ऊपर: एक mean- पर लगभग ऊपरी दो प्रतिशत100, एसडी-15 मॉडल"
      ]
    },
    {
      "heading": "एक उच्च कम्पोजिट में एक अनियमित प्रोफ़ाइल हो सकता है",
      "paragraphs": [
        "किसी व्यक्ति का विशेष रूप से मासिक तर्क, दृश्य तर्क, कार्य स्मृति, या प्रक्रिया गति में मजबूत प्रदर्शन हो सकता है जबकि अन्य क्षेत्र उनके आयु समूह औसत के करीब है।",
        "एक उच्च स्कोर व्यक्तित्व, रचनात्मकता, प्रेरणा, या भविष्य की उपलब्धियों को निर्धारित नहीं करता है।"
      ]
    },
    {
      "heading": "सटीकता और जिम्मेदार व्याख्या",
      "paragraphs": [
        "प्रत्येक स्कोर में माप अनिश्चितता है. पेशेवर रिपोर्ट आमतौर पर एक विश्वास अंतराल शामिल करते हैं क्योंकि परिणाम 129 से अर्थपूर्ण रूप से अलग नहीं है. 130 एक पूरी तरह से स्पष्ट सीमा के साथ.",
        "शिक्षा, नैदानिक समर्थन या योग्यता के बारे में निर्णय एक उपयुक्त निगरानी उपकरण और योग्य व्याख्या पर निर्भर होना चाहिए।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "एक IQ है 120 उच्च माना जाता है?",
      "answer": "यह लगभग 100 किमी. है। 91औसत पर 100%100, एसडी-15 यह आमतौर पर एक मॉडल है और आमतौर पर औसत से ऊपर भी वर्णित किया जाता है, लेकिन लेबल परीक्षण द्वारा भिन्न होते हैं।"
    },
    {
      "question": "क्या उच्च IQ सफलता की गारंटी है?",
      "answer": "नहीं। उपलब्धि ज्ञान, प्रेरणा, स्वास्थ्य, व्यक्तित्व, अवसर, दृढ़ता और वातावरण पर भी निर्भर करती है।"
    }
  ],
  "related": ["what-does-an-iq-of-120-mean", "iq-130-meaning", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "गूगल शब्दकोश - IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "पीरसन - डब्ल्यूएआईएस-5 नमूना अंक रिपोर्ट",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
